/**
 * Destinazioni della barra 48 px: solo moduli globali, filtrati da Whoami.may.
 */
import {
  AUDIT_READ,
  CATALOG_IMPORT,
  EXPORT_RECEIPT_READ,
  INSPECTION_POOL_READ,
  MODEL_MANAGE,
  PACKAGE_UPLOAD,
  SETTINGS_MANAGE,
  USER_MANAGE,
  type Whoami,
} from '../auth'
import type { MessageKey } from '../i18n/messages'

export interface RailItem {
  id: string
  to: string
  label: MessageKey
}

export function adminHomePath(who: Whoami): string | null {
  if (who.may.includes(USER_MANAGE)) return '/admin/users'
  if (who.may.includes(MODEL_MANAGE)) return '/admin/model'
  if (who.may.includes(SETTINGS_MANAGE)) return '/admin/settings'
  if (who.may.includes(CATALOG_IMPORT)) return '/admin/catalog'
  if (who.may.includes(AUDIT_READ)) return '/admin/audit'
  // L'esercizio — cio' che la sentinella vede — e' una scheda
  // dell'amministrazione (GI-279): un modulo a parte con una schermata sola
  // era una porta in piu' per la stessa stanza.
  if (who.may.includes(SETTINGS_MANAGE)) return '/operations'
  return null
}

export function railItems(who: Whoami): RailItem[] {
  const items: RailItem[] = []
  if (who.may.includes(INSPECTION_POOL_READ)) {
    items.push({ id: 'work', to: '/work', label: 'rail.work' })
  }
  if (who.may.includes(EXPORT_RECEIPT_READ)) {
    // Le consegne partite vivono qui e non dentro una commessa: la ricevuta
    // che si apre sei mesi dopo si cerca senza sapere da quale commessa venga.
    items.push({ id: 'deliveries', to: '/exports', label: 'rail.deliveries' })
  }
  if (who.may.includes(PACKAGE_UPLOAD)) {
    items.push({ id: 'upload', to: '/uploads/new', label: 'rail.upload' })
  }
  const admin = adminHomePath(who)
  if (admin !== null) {
    items.push({ id: 'admin', to: admin, label: 'rail.admin' })
  }
  return items
}
